<template>
  <div class="cadastro-publico">
    <!-- Painel lateral (visível em telas grandes) -->
    <div class="painel-lateral">
      <div class="painel-conteudo">
        <div class="marca">
          <div class="marca-icone">
            <i class="fas fa-dumbbell"></i>
          </div>
          <h1>Diário de Treino</h1>
          <p class="marca-subtitulo">Rede de afiliados</p>
        </div>

        <div class="beneficios">
          <h6 class="beneficios-titulo">
            <i class="fas fa-star"></i>
            Vantagens de fazer parte
          </h6>
          <ul>
            <li>
              <i class="fas fa-users"></i>
              <div>
                <strong>Monte sua rede</strong>
                <small>Indique outros treinadores e cresça</small>
              </div>
            </li>
            <li>
              <i class="fas fa-chart-line"></i>
              <div>
                <strong>Acompanhe em tempo real</strong>
                <small>Veja o crescimento da sua equipe</small>
              </div>
            </li>
            <li>
              <i class="fas fa-trophy"></i>
              <div>
                <strong>Suba de rank</strong>
                <small>Ganhe reconhecimento pelo seu trabalho</small>
              </div>
            </li>
          </ul>
        </div>

        <div class="painel-rodape">
          <i class="fas fa-lock"></i>
          Seus dados estão seguros e protegidos
        </div>
      </div>
    </div>

    <!-- Coluna do formulário -->
    <div class="coluna-form">
      <div class="form-wrapper">
        <!-- Estado: carregando patrocinador -->
        <div v-if="loading" class="estado-box">
          <i class="fas fa-spinner fa-spin fa-3x text-primary"></i>
          <p class="mt-3 text-muted">Validando convite...</p>
        </div>

        <!-- Estado: link inválido -->
        <div v-else-if="linkInvalido" class="estado-box">
          <div class="estado-icone bg-danger-soft">
            <i class="fas fa-exclamation-triangle text-danger"></i>
          </div>
          <h3 class="mt-3">Link inválido ou expirado</h3>
          <p class="text-muted">
            Este link de convite não pôde ser validado.
          </p>
          <p class="text-muted small">
            Entre em contato com quem te convidou para obter um novo link.
          </p>
        </div>

        <!-- Estado: sucesso -->
        <div v-else-if="cadastrado" class="estado-box">
          <div class="estado-icone bg-success-soft">
            <i class="fas fa-check-circle text-success"></i>
          </div>
          <h3 class="mt-3">Cadastro realizado!</h3>
          <p class="text-muted">
            Seja bem-vindo(a) à rede, <strong>{{ form.nome }}</strong>!
          </p>

          <div class="codigo-destaque">
            <small>Seu código de indicação</small>
            <code>{{ meuCodigo }}</code>
            <button class="btn-copy" @click="copiarCodigo" :title="copiado ? 'Copiado!' : 'Copiar'">
              <i :class="copiado ? 'fas fa-check' : 'far fa-copy'"></i>
            </button>
          </div>

          <div class="proximos-passos">
            <h6><i class="fas fa-info-circle me-1"></i> Próximos passos</h6>
            <ul>
              <li>Você receberá um e-mail com as instruções para completar seu cadastro</li>
              <li>Assim que o gestor aprovar, sua conta ficará ativa</li>
              <li>Comece a compartilhar seu código e construir sua rede</li>
            </ul>
          </div>
        </div>

        <!-- Formulário principal -->
        <template v-else-if="patrocinador">
          <div class="form-header">
            <h2>Preencha seus dados</h2>
            <p class="text-muted small mb-0">Cadastro rápido, leva menos de 1 minuto</p>
          </div>

          <div class="convite-card">
            <div class="convite-avatar">
              {{ iniciais(patrocinador.nome) }}
            </div>
            <div class="convite-info">
              <small class="convite-label">Você foi convidado por</small>
              <strong>{{ patrocinador.nome }}</strong>
              <span class="convite-codigo">
                <i class="fas fa-tag"></i> {{ patrocinador.codigoIndicacao }}
              </span>
            </div>
          </div>

          <form @submit.prevent="enviar" class="form-cadastro">
            <div class="campo">
              <label>
                <i class="fas fa-user"></i>
                Nome completo *
              </label>
              <input v-model="form.nome" type="text" required maxlength="150" placeholder="Seu nome" />
            </div>

            <div class="row-campos">
              <div class="campo">
                <label>
                  <i class="fas fa-envelope"></i>
                  E-mail *
                </label>
                <input v-model="form.email" type="email" required maxlength="150" placeholder="seu@email.com" />
              </div>
              <div class="campo">
                <label>
                  <i class="fab fa-whatsapp"></i>
                  Telefone (WhatsApp)
                </label>
                <input v-model="form.telefone" type="tel" maxlength="20" placeholder="(11) 99999-9999" />
              </div>
            </div>

            <div class="row-campos">
              <div class="campo">
                <label>
                  <i class="fas fa-id-card"></i>
                  CPF
                </label>
                <input v-model="form.cpf" type="text" maxlength="14" placeholder="000.000.000-00" />
              </div>
              <div class="campo">
                <label>
                  <i class="fas fa-birthday-cake"></i>
                  Data de nascimento
                </label>
                <input v-model="form.dataNascimento" type="date" />
              </div>
            </div>

            <div class="alert-info">
              <i class="fas fa-info-circle"></i>
              <div>
                Ao cadastrar, você entra na rede como <strong>treinador afiliado</strong>.
                Sua conta ficará pendente até o gestor ativar.
              </div>
            </div>

            <button type="submit" class="btn-cadastrar" :disabled="enviando">
              <i v-if="enviando" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-user-plus"></i>
              {{ enviando ? 'Enviando...' : 'Cadastrar na Rede' }}
            </button>

            <div v-if="erroEnvio" class="erro-envio">
              <i class="fas fa-exclamation-circle"></i> {{ erroEnvio }}
            </div>
          </form>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import redeMarketingApi from '@/services/api/redeMarketingRepository'

const route = useRoute()
const codigoRef = route.query.ref

const loading = ref(true)
const linkInvalido = ref(false)
const patrocinador = ref(null)
const cadastrado = ref(false)
const meuCodigo = ref(null)
const enviando = ref(false)
const erroEnvio = ref('')
const copiado = ref(false)

const form = ref({
  nome: '',
  email: '',
  cpf: '',
  telefone: '',
  dataNascimento: null,
})

function iniciais(nome) {
  if (!nome) return '?'
  const p = nome.trim().split(/\s+/)
  return (p.length === 1 ? p[0].substring(0, 2) : p[0][0] + p[p.length - 1][0]).toUpperCase()
}

async function copiarCodigo() {
  if (!meuCodigo.value) return
  try {
    await navigator.clipboard.writeText(meuCodigo.value)
    copiado.value = true
    setTimeout(() => { copiado.value = false }, 2000)
  } catch {
    // ignorar — alguns navegadores bloqueiam clipboard em contextos não-https
  }
}

onMounted(async () => {
  if (!codigoRef) {
    linkInvalido.value = true
    loading.value = false
    return
  }
  try {
    const resp = await redeMarketingApi.BuscarPatrocinadorPublico(codigoRef)
    patrocinador.value = resp.data
    if (!resp.data.ativo) {
      linkInvalido.value = true
    }
  } catch (e) {
    console.warn('[CadastroAfiliado] patrocinador nao encontrado:', e.message)
    linkInvalido.value = true
  } finally {
    loading.value = false
  }
})

async function enviar() {
  enviando.value = true
  erroEnvio.value = ''
  try {
    const payload = {
      codigoPatrocinador: codigoRef,
      nome: form.value.nome,
      email: form.value.email,
      cpf: form.value.cpf || null,
      telefone: form.value.telefone || null,
      dataNascimento: form.value.dataNascimento || null,
    }
    const resp = await redeMarketingApi.CadastroPublico(payload)
    meuCodigo.value = resp.data.codigoIndicacao
    cadastrado.value = true
  } catch (e) {
    erroEnvio.value = e.response?.data?.message || e.message || 'Erro ao cadastrar'
  } finally {
    enviando.value = false
  }
}
</script>

<style scoped>
.cadastro-publico {
  min-height: 100vh;
  background: #f8fafc;
  display: flex;
}

/* ========== PAINEL LATERAL (esquerda) ========== */
.painel-lateral {
  flex: 0 0 42%;
  background: linear-gradient(135deg, #2D3A7C 0%, #4f46e5 60%, #7c3aed 100%);
  color: #fff;
  padding: 40px 32px;
  position: relative;
  overflow: hidden;
}
/* Forca branco em TODOS os textos do painel lateral
   (o template global do Diario de Treino define cores escuras
   em h1/h6/strong/small que sobrescrevem o color herdado). */
.painel-lateral,
.painel-lateral h1,
.painel-lateral h6,
.painel-lateral strong,
.painel-lateral small,
.painel-lateral p,
.painel-lateral li,
.painel-lateral i {
  color: #fff !important;
}
.painel-lateral::before {
  content: '';
  position: absolute;
  top: -120px; right: -120px;
  width: 300px; height: 300px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 50%;
}
.painel-lateral::after {
  content: '';
  position: absolute;
  bottom: -100px; left: -100px;
  width: 260px; height: 260px;
  background: rgba(247, 148, 29, 0.15);
  border-radius: 50%;
}
.painel-conteudo {
  position: relative;
  z-index: 1;
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: calc(100vh - 80px);
}

.marca { margin-bottom: 48px; }
.marca-icone {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #F7941D 0%, #f5a623 100%);
  border-radius: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  color: #fff;
  margin-bottom: 16px;
  box-shadow: 0 8px 20px rgba(247, 148, 29, 0.4);
}
.marca h1 {
  font-size: 1.9rem;
  font-weight: 800;
  margin: 0;
  letter-spacing: -0.5px;
}
.marca-subtitulo {
  opacity: 0.9;
  font-size: 0.95rem;
  margin-top: 4px;
}

.beneficios-titulo {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  opacity: 0.85;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.beneficios ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.beneficios li {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.beneficios li i {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  flex-shrink: 0;
}
.beneficios li strong { display: block; font-size: 0.95rem; line-height: 1.3; }
.beneficios li small { display: block; opacity: 0.85; font-size: 0.82rem; margin-top: 2px; line-height: 1.35; }

.painel-rodape {
  margin-top: auto;
  padding-top: 30px;
  font-size: 0.78rem;
  opacity: 0.85;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* ========== COLUNA DO FORMULÁRIO (direita) ========== */
.coluna-form {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}
.form-wrapper {
  width: 100%;
  max-width: 480px;
}

.form-header { margin-bottom: 18px; }
.form-header h2 {
  font-size: 1.5rem;
  color: #1e293b;
  font-weight: 700;
  margin: 0 0 4px 0;
}

/* Card do patrocinador */
.convite-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  padding: 14px 18px;
  margin-bottom: 22px;
}
.convite-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: #fff;
  font-weight: 700;
  font-size: 0.95rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.25);
}
.convite-info { line-height: 1.2; }
.convite-label {
  color: #64748b;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.convite-info strong {
  display: block;
  color: #1e293b;
  font-size: 1.02rem;
  margin: 2px 0;
}
.convite-codigo {
  font-size: 0.78rem;
  color: #4338ca;
  font-weight: 600;
}
.convite-codigo i { font-size: 0.7rem; margin-right: 4px; }

/* Formulário */
.form-cadastro {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.campo label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #334155;
  margin-bottom: 6px;
}
.campo label i { color: #64748b; font-size: 0.82rem; }
.campo input {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.95rem;
  background: #fff;
  transition: all 0.15s;
}
.campo input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);
}
.row-campos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 500px) {
  .row-campos { grid-template-columns: 1fr; }
}

.alert-info {
  background: #f1f5f9;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 0.82rem;
  color: #475569;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  line-height: 1.4;
}
.alert-info i { color: #4f46e5; font-size: 1rem; }

.btn-cadastrar {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: #fff;
  border: none;
  padding: 14px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.98rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.15s;
  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.3);
}
.btn-cadastrar:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.4);
}
.btn-cadastrar:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.erro-envio {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 0.88rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Estados (loading / erro / sucesso) */
.estado-box {
  text-align: center;
  padding: 30px 10px;
}
.estado-icone {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 2.2rem;
}
.bg-success-soft { background: #dcfce7; }
.bg-danger-soft { background: #fee2e2; }
.estado-box h3 {
  font-size: 1.4rem;
  color: #1e293b;
  font-weight: 700;
}

.codigo-destaque {
  margin-top: 22px;
  padding: 16px 18px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 2px dashed #22c55e;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
.codigo-destaque small {
  color: #166534;
  font-size: 0.82rem;
  font-weight: 600;
  flex-basis: 100%;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.codigo-destaque code {
  background: #16a34a;
  color: #fff;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: 0.5px;
  font-family: 'Courier New', monospace;
}
.btn-copy {
  width: 38px;
  height: 38px;
  background: #fff;
  border: 1.5px solid #22c55e;
  border-radius: 8px;
  color: #16a34a;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-copy:hover {
  background: #16a34a;
  color: #fff;
}

.proximos-passos {
  margin-top: 24px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px 18px;
  text-align: left;
}
.proximos-passos h6 {
  font-size: 0.85rem;
  color: #475569;
  margin: 0 0 10px 0;
}
.proximos-passos ul {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.85rem;
  color: #475569;
}
.proximos-passos li {
  padding: 5px 0 5px 20px;
  position: relative;
  line-height: 1.4;
}
.proximos-passos li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #22c55e;
  font-weight: 700;
}

/* ========== RESPONSIVO ========== */
@media (max-width: 900px) {
  .cadastro-publico { flex-direction: column; }
  .painel-lateral {
    flex: none;
    padding: 24px 20px 40px;
  }
  .painel-conteudo { min-height: auto; }
  .beneficios { margin-bottom: 10px; }
  .painel-rodape { margin-top: 20px; }
  .marca { margin-bottom: 24px; text-align: center; }
  .coluna-form { padding: 30px 16px; }
}
</style>
